import React from 'react';
import styles from '../../../css/services/conServices.module.css';
import { Helmet } from 'react-helmet';
function NajizServices() {
    return (
        <>
            <Helmet>
                {/* البيانات الأساسية */}
                <title>خدمات ناجز الإلكترونية | تفعيل حساب، إصدار وفسخ وكالة - خطوة المستثمر</title>
                <meta name="description" content="نقدم خدمات ناجز الإلكترونية للمنشآت والأفراد في المملكة العربية السعودية، بما في ذلك تفعيل حساب منشأة، إصدار وكالة إلكترونية، وفسخها." />
                <meta name="keywords" content="ناجز، خدمات ناجز، تفعيل حساب منشأة، إصدار وكالة، فسخ وكالة، خطوة المستثمر، خدمات إلكترونية" />
                <meta name="author" content="خطوة المستثمر" />

                {/* بيانات Open Graph (لوسائل التواصل الاجتماعي) */}
                <meta property="og:title" content="خدمات ناجز الإلكترونية - خطوة المستثمر" />
                <meta property="og:description" content="نوفر حلولاً متكاملة لإدارة خدماتك على منصة ناجز، من تفعيل الحساب إلى إدارة الوكالات." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.khotwatalmostathmer.com/services/najiz" />
                <meta property="og:image" content="https://www.khotwatalmostathmer.com/images/najiz-service-og.jpg" />
                <meta property="og:site_name" content="خطوة المستثمر" />

                {/* بيانات Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="خدمات ناجز الإلكترونية - خطوة المستثمر" />
                <meta name="twitter:description" content="نوفر حلولاً متكاملة لإدارة خدماتك على منصة ناجز." />
                <meta name="twitter:image" content="https://www.khotwatalmostathmer.com/images/najiz-service-twitter.jpg" />

                {/* كانونيكال URL */}
                <link rel="canonical" href="https://www.khotwatalmostathmer.com/services/najiz" />

                {/* بيانات المنظمة (Schema.org) */}
                <script type="application/ld+json">
                    {`
                {
                    "@context": "https://schema.org",
                    "@type": "Service",
                    "serviceType": "خدمات ناجز الإلكترونية",
                    "provider": {
                        "@type": "Organization",
                        "name": "خطوة المستثمر"
                    },
                    "description": "نقدم خدمات شاملة على منصة ناجز، بما في ذلك تفعيل حسابات المنشآت وإدارة الوكالات.",
                    "areaServed": {
                        "@type": "Country",
                        "name": "SA"
                    }
                }
                `}
                </script>
            </Helmet>
            <div className={styles.container}>
                <div className={styles.services}>
                    <div>
                        <h1>1. تفعيل حساب منشأة</h1>
                        <p>
                            خدمة تمكين المنشأة من فتح حساب رسمي لضمان
                            <br/>
                            تقديم الخدمات الحكومية
                        </p>
                    </div>
                    <div>
                        <h1>2. إصدار وكالة</h1>
                        <p>
                            خدمة منح صلاحيات رسمية لشخص آخر لتنفيذ
                            <br/>
                            مهمة بالنيابة
                        </p>
                    </div>
                    <div>
                        <h1>3. فسخ وكالة</h1>
                        <p>
                            خدمة إلغاء التفويض الرسمي الممنوح لشخص
                            <br/>
                            لتنفيذ مهمة بالنيابة
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NajizServices; 